import { render, staticRenderFns } from "./SelectAreaPage.vue?vue&type=template&id=66c52c4e&"
import script from "./SelectAreaPage.vue?vue&type=script&lang=ts&"
export * from "./SelectAreaPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports